import React, { useEffect, useState } from 'react'
import { getAllCompanies, getOrganizationWiseResult } from '../../../services/api-services';
import { toastEmitter } from '../../../utills/utilities';
import { API_RESPONSE } from '../../../utills/app-constant';
import DropDownWithLabel from '../../components/common/DropDownWithlable';
import TableHeading from '../../components/common/TableHeading';
import { RIGHTARROW_ICON } from '../../../utills/image-constant';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const ComapnyWiseUserResult = () => {
    const [companyList, setCompanyList] = useState([]);
    const [resultList, setResultList] = useState([]);
    const [selectedCompanyId, setSelectedCompanyId] = useState("");

    const getallCompany = async () => {
        try {
            const response = await getAllCompanies();
            if (response?.data?.responseCode === 404) {
                setCompanyList([]);
            } else if (response?.data?.responseCode === 200) {
                const companyOptions = response?.data?.responseBody?.map((data) => ({
                    value: data?.id,
                    label: data?.companyName,
                    Status: data?.status,
                }));
                setCompanyList(companyOptions);
            } else {
                toastEmitter("error", response?.data?.message);
            }
        } catch (err) {
            toastEmitter("error", API_RESPONSE.MESSAGE_503);
        }
    };

    useEffect(() => {
        getallCompany();
    }, []);

    const getResult = async (value) => {
        try {
            const response = await getOrganizationWiseResult(value);
            if (response?.data?.responseCode === 404) {
                setResultList([]);
            } else if (response?.data?.responseCode === 200) {
                setResultList(response?.data?.data);
            } else {
                toastEmitter("error", response?.data?.message);
            }
        } catch (err) {
            toastEmitter("error", API_RESPONSE.MESSAGE_503);
        }
    }

    const handleSelect = (event) => {
        const selectedCompanyId = event.target.value;
        setSelectedCompanyId(selectedCompanyId);
        if (event.target.value) {
            getResult(event.target.value)
        }
    };

    // Helper to map label to number
    const maturityLevelMap = {
        Initiating: 1,
        Emerging: 2,
        Performing: 3,
        Advancing: 4,
        Leading: 5
    };

    const exportGroupedQuestionnaireToExcel = (data, fileName = "Download Result") => {
        const sheetRows = [];

        // 1) Header row
        sheetRows.push([
            "Employee",
            ...data.map(u => u.employeeName || "Unnamed User")
        ]);

        // 2) Static fields
        [
            { key: "department", label: "Department" },
            { key: "hierarchy", label: "Hierarchy" },
            { key: "submissionDate", label: "Submission" }
        ].forEach(({ key, label }) => {
            sheetRows.push([
                label,
                ...data.map(u => u[key] || "NIL")
            ]);
        });

        // 3) One blank row before questions
        sheetRows.push([]);

        // 4) Questions blocks with numbering
        const allQuestions = Array.from(
            new Set(data.flatMap(u => u.individualResultQueResList?.map(q => q.question) || []))
        );

        //const allQuestions = data[0]?.individualResultQueResList?.map(q => q.question) || [];
        const answerTypes = ["current", "future", "important"];

        allQuestions.forEach((question, qi) => {
            const qLabel = `${qi + 1}. ${question}`;

            // a) Numbered Question title row
            sheetRows.push([qLabel, ...data.map(() => "")]);

            // b) Current / Future / Important rows
            answerTypes.forEach(type => {
                const typeLabel = type.charAt(0).toUpperCase() + type.slice(1);
                sheetRows.push([
                    `  ${typeLabel}`,
                    ...data.map(user => {
                        const found = user.individualResultQueResList?.find(q => q.question === question);
                        const val = found?.[type];
                        return val ? `${maturityLevelMap[val]} - ${val}` : "NIL";
                    })
                ]);
            });

            // c) Blank row after each question block
            sheetRows.push([]);
        });

        // 5) Build workbook & trigger download
        const worksheet = XLSX.utils.aoa_to_sheet(sheetRows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Aggregated Report");

        const buf = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([buf], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        saveAs(blob, fileName);

    };

    return (
        <>
            <div className="overall-result">
                <div className="overall-result-content">
                    <div className="page-title">
                        <h5 className="mb-2">Download Result</h5>

                    </div>
                    <div className="row">
                        <div className="col-md-6 mb-4">
                            <DropDownWithLabel
                                labelName="Select Organization"
                                lableclassName="input-label"
                                name="companyId"
                                showastrict={true}
                                options={companyList}
                                className="form-control inputText-lable"
                                value={selectedCompanyId}
                                handleSelect={handleSelect}
                            />
                        </div>
                    </div>
                    {!selectedCompanyId && (
                        <div className="selectCompany mb-2">
                            <TableHeading
                                firstData="Please Select "
                                icon={RIGHTARROW_ICON}
                                TableHeading="mb-0"
                                secondclassName="textcolor"
                                className="textcolor"
                                secondData="Organization"
                            />
                        </div>
                    )}

                    {
                        (selectedCompanyId && resultList?.length) && <div className='selectCompany'> <button className="px-3 py-2 text-white bg-primary rounded border-0" onClick={() => exportGroupedQuestionnaireToExcel(resultList)}>Download Excel</button></div>
                    }


                </div>
            </div>
        </>
    )
}

export default ComapnyWiseUserResult;
